// Isotopes of the eluated nuclides
export enum GeneratorEluateIsotope {

	GALLIUM_68_GA = 'GALLIUM_68_GA',

	TECHNETIUM_99M_TC = 'TECHNETIUM_99M_TC'
}
